import { render } from "./PasswordInputAndConfirm.vue?vue&type=template&id=5494baac&scoped=true"
import script from "./PasswordInputAndConfirm.vue?vue&type=script&lang=js"
export * from "./PasswordInputAndConfirm.vue?vue&type=script&lang=js"

import "./PasswordInputAndConfirm.vue?vue&type=style&index=0&id=5494baac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5494baac"]])

export default __exports__